import { useNavigate } from "react-router-dom";

const UsertableComponent = ({ allUser }: any) => {
  const navigate = useNavigate();

  return (
    <>
      <table className="w-full text-sm text-left  h-40 mb-9">
        <thead className="text-xs font-Roboto font-normal text-lightgray ">
          <tr>
            <th scope="col" className="p-4">
              <div className="flex items-center"></div>
            </th>
            <th scope="col" className="">
              Name
            </th>
            <th scope="col" className="">
              Email
            </th>
            <th scope="col" className="">
              Phone No.
            </th>
            <th scope="col" className="">
              Joined
            </th>
          </tr>
        </thead>
        <tbody>
          {allUser &&
            allUser?.length > 0 &&
            allUser?.map((elm: any, index: any) => (
              <tr
                key={elm.firstName + index}
                className="bg-white border-b border-aqua cursor-pointer hover:bg-gray-50 transition"
                onClick={() => navigate(`/users/${elm.id}`)}
              >
                <td className="w-4 p-4">
                  <div className="flex items-center"></div>
                </td>
                <td className="font-medium">{elm.firstName}</td>
                <td className="">{elm.email}</td>
                <td className="">
                  <span className="text-gray-600">
                    {elm.contact || "—"}
                  </span>
                </td>
                <td className="text-gray-500 text-xs">
                  {elm.createdAt ? new Date(elm.createdAt).toLocaleDateString() : "—"}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default UsertableComponent;
